import { render, staticRenderFns } from "./FrequentQuestionForm.vue?vue&type=template&id=f40680c4&"
import script from "./FrequentQuestionForm.vue?vue&type=script&lang=js&"
export * from "./FrequentQuestionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports